























































import ToggleSwitch from './ToggleSwitch.vue'
import { Icon } from '@alpha/ink'
import AssetLoader from './AssetLoader.vue'
import Redactor from '../Redactor.vue'
import { get } from 'lodash-es'
import A from '@/utilities/alpha'
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({
  components: {
    ToggleSwitch,
    Icon,
    AssetLoader,
    Redactor
  }
})

export default class SharedReportAsset extends Vue {
  @Prop({ required: true }) asset!: any
  @Prop({ required: true }) order!: String
  @Prop({ required: true }) drop!: any
  @Prop({ required: true }) lastIndex!: Number
  @Prop({ required: true }) qualNotable!: Array<any>
  @Prop({ required: true }) visible!: Boolean
  @Prop({ required: true }) editable!: Boolean
  @Prop({ required: true }) index!:Number

  currentSlice:any = ''

  get iconName ():any {
    return this.visible ? 'keyboard_arrow_down' : 'chevron_right'
  }

  get activeClientAnalysis ():any {
    if (this.currentKey) {
      return get(this, `assetSlices.${this.currentKey}.analysis`, '')
    } else {
      return this.asset.analysis || ''
    }
  }

  set activeClientAnalysis (content:any) {
    if (this.currentKey && this.assetSlices[this.currentKey]) { // slice exists
      this.assetSlices[this.currentKey].analysis = content
    } else { // or use main charts client analysis
      this.asset.analysis = content
    }
  }

  get currentAnalysis ():any {
    if (!this.currentKey || this.assetSlices[this.currentKey].alphaAnalysis === undefined) {
      return this.asset.alphaAnalysis
    } else {
      const chart = this.assetSlices[this.currentKey]
      return chart.alphaAnalysis
    }
  }

  set currentAnalysis (newValue:any) {
    if (!this.currentKey || this.assetSlices[this.currentKey].alphaAnalysis === undefined) {
      this.$set(this.asset, 'alphaAnalysis', newValue)
    } else {
      const chart = this.assetSlices[this.currentKey]
      this.$set(chart, 'alphaAnalysis', newValue)
    }
  }

  get assetSlices ():any {
    const { charts, textResponses } = this.asset
    return charts || textResponses
  }

  get currentKey ():any {
    if (!this.currentSlice || this.currentSlice === 'original') return false
    const sliceKeys = Object.keys(this.assetSlices)
    let curKey = sliceKeys.find(key => this.assetSlices[key].title.includes(this.currentSlice))
    if (!curKey) curKey = sliceKeys.find(key => key.includes(this.currentSlice))
    return curKey
  }

  toggleAsset (index:any, $event:any) {
    const toggleIcon:any = this.$refs.toggleIcon
    if (!this.editable || $event.target === toggleIcon.$el) {
      this.$emit('toggleAsset', this.order, index, event)
    }
  }

  moveAsset (index:any, direction:any) {
    this.$emit('moveAsset', index, direction)
  }

  updateAssetCount = 0;

  updateAsset (asset:any) {
    this.$emit('updateAsset', { asset, key: this.order })
  }

  updateCurrentSlice (sliceName:any) {
    this.currentSlice = sliceName
  }

  getStripped (txt:any):any {
    return A.stripHTML(txt)
  }
}
